module.exports = __webpack_public_path__ + "img/shouye-chengjiaoanli-png.d4c89f8d.png";